import React from 'react';

export default {
  banner: {
    title: 'Gator Protect',
    description: 'Powered by Monarx AI',
    selectPlanLabel: 'Confira a proteção da hospedagem para:',
    mainDomain: 'domínio principal:',
    proBadgeLabel: 'PRO',
    img: {
      alt: 'Snappy Monarx',
    },
  },
  summary: {
    threatsIdentified: 'Ameaças identificadas',
    threatsRemediated: 'Ameaças eliminadas',
    keepProtected: 'Mantenha seu site protegido!',
    keepProtectedDescription: 'Não espere o período de teste da proteção completa acabar. Mantenha a proteção e fique tranquilo!',
    keepProtectionActive: 'Manter proteção ativa',
    withoutLastScan: {
      title: 'Aguardando a primeira varredura',
      description: 'Seu site está em monitoramento constante, as ameaças identificadas serão listadas aqui.',
    },
    enableYourProtection: (
      <>
        Não deixe seu site vulnerável.
        <br/>
        Ative a remoção automática de ameaças.
      </>
    ),
    protectionCard: {
      trialIsActive: {
        title: 'Proteção automática disponível',
        description: 'Ative agora para remover as ameaças identificadas automaticamente.',
        actions: [
          {
            key: 'activateProtectionPro',
            label: 'Ativar Proteção Pro',
            variant: 'primary',
          },
        ],
      },
      automaticProtectionAvailable: {
        title: 'Proteção automática disponível',
        description: 'Ative agora para remover as ameaças identificadas automaticamente.',
        activateProtectionPro: {
          key: 'activateProtectionPro',
          label: 'Ativar Proteção Pro',
          variant: 'secondary',
        },
        activateTrial: {
          regular: {
            key: 'activateTrial',
            label: 'Testar 30 dias grátis',
            variant: 'primary',
          },
          aa: {
            key: 'activateTrial',
            label: 'Testar 1 ano grátis',
            variant: 'primary',
          },
        },
      },
      safeWithoutInterruption: {
        title: 'Continue seguro sem interrupções.',
        description: 'Durante o período de teste, o Gator Protect Pro já protege seu site contra ameaças reais, de forma automática.',
        actions: [
          {
            key: 'keepProtectionActive',
            label: 'Manter proteção ativa',
            variant: 'primary',
          },
        ],
      },
      pendingInvoice: {
        title: 'Sua proteção está quase ativa!',
        description: 'Finalize o pagamento na aba "Faturas" para ativar o serviço.',
        goToInvoices: 'Ir para Faturas',
      },
    },
    protectionModal: {
      common: {
        productTitle: 'Gator Protect',
        productSubtitle: 'Powered by Monarx AI',
        proBadgeLabel: 'PRO',
        checklistItems: [
          'Remoção automática de ameaças',
          'Monitoramento contínuo do site',
          'Atendimento especializado',
          'Proteção ativa 24h',
        ],
      },
      trialActivation: {
        title: isAa => `Ative agora e não pague nada por ${isAa ? '1 ano' : '30 dias'}`,
        subtitle: price => `Após o período gratuito, assine por apenas ${price} por mês`,
        buttonLabel: 'Ativar teste gratuito',
      },
      trialActive: {
        title: 'Continue com a proteção completa ativa',
        subtitle: 'Após o período de teste, a remoção automática será desativada.',
        message: daysLeft => (daysLeft >= 0 ? `Seu teste encerra em ${daysLeft} dias.` : ''),
        buttonLabel: price => `Ativar agora por ${price}/mês`,
      },
      proActivation: {
        title: 'Proteção completa para seus projetos',
        subtitle: 'Garanta monitoramento contínuo e remoção automática de ameaças.',
        buttonLabel: price => (price ? `Ativar agora por ${price}/mês` : 'Ativar proteção Pro'),
      },
    },
    automaticCleaningConsentModal: {
      title: 'Confirme a limpeza automática',
      description: 'Autorizo a remoção dos arquivos infectados e estou ciente de que o processo pode causar perda de páginas ou impactar o funcionamento do site. Não responsabilizo o suporte da HostGator por este processo.',
      checkboxLabel: 'Li e aceito',
      cancelButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Iniciar limpeza',
    },
    alerts: {
      fullProtectionActive: (
        <>
          <strong>Proteção completa ativa.</strong>
          {' Seu site sempre seguro!'}
        </>
      ),
      cleaningInProgress: 'Sua limpeza está em andamento. Aguarde até 24h para realizar uma nova solicitação.',
      expiredProtection: 'A proteção do seu site acabou. Não deixe seu site vulnerável a ameaças.',
      trialActive: daysLeft => (
        <>
          <strong>Seu período de teste ainda está ativo.</strong>
          {` Seu site protegido por mais ${daysLeft} dias!`}
        </>
      ),
      teamIntervention: {
        title: threatsNumber => `Você tem ${threatsNumber} ameaças que precisam de intervenção da nossa equipe!`,
        description: 'Para que a equipe continue a análise e o tratamento, é preciso abrir um chamado.',
        buttonLabel: 'Abrir chamado',
      },
      teamInterventionResolved: {
        title: 'A ameaça foi analisada e eliminada pela nossa equipe',
        description: 'Sua hospedagem continua protegida com monitoramento automático de novas ameaças.',
        buttonLabel: 'Acessar chamado',
      },
    },
    automaticRemovalToggle: {
      automaticRemovalLabel: isActive => (
        <>
          {'Remoção automática de ameaças '}
          <strong>{isActive ? 'ativada' : 'desativada'}</strong>
        </>
      ),
      automaticRemovalTooltip: 'Quando ativado, o sistema identifica e remove automaticamente ameaças no seu site.',
      lastVerification: ({ hour, day }) => (
        <>
          <strong>Monitoramento constante. Ultima verificação:</strong>
          {` ${day} às ${hour}`}
        </>
      ),
      noData: 'Aguardando primeira varredura',
    },
  },
  threatsTable: {
    columns: {
      file: 'Arquivo',
      threat: 'Ameaça',
      situation: 'Situação',
      detectedAt: 'Data de identificação',
    },
    situationTags: {
      quarantine: 'Ameaça não removida',
      remediated: 'Eliminada',
    },
    header: {
      exportButtonAriaLabel: 'Exportar',
      infoPlaceholder: 'Últimos 30 dias',
    },
    tags: {
      detected: 'Ameaça não removida',
      remediated: 'Eliminada',
    },
  },
  activitiesChart: {
    title: 'Atividades detectadas',
    filter: {
      last30Days: 'Últimos 30 dias',
    },
    compromisedFilesLabel: 'Arquivos comprometidos',
    maliciousCodesLabel: 'Arquivos maliciosos',
    emptyTitle: 'Nenhuma atividade',
    emptyImageAlt: 'Nenhuma atividade',
    emptyDescription: 'Nenhuma ameaça identificada ou arquivos suspeitos nos últimos 30 dias.',
  },
  terms: {
    label: 'Li e aceito os ',
    cta: 'Termos e Condições',
  },
  acknowledgedModal: {
    title: {
      trial: ({ days }) => `Teste grátis por ${days} dias · Ativo`,
      pro: ({ plan }) => `Proteção Pro ativa · incluída no seu plano ${plan}`,
    },
    secondTitle: {
      trial: ({ days }) => `Seu site está protegido automaticamente por ${days} dias`,
      pro: 'Seu site agora tem proteção automática',
    },
    description: {
      trial: (
        <>
          {'Ativamos o '}
          <strong>Gator Protect Pro</strong>
          {' na sua hospedagem para ajudar a manter seu site seguro no dia a dia.'}
        </>
      ),
      pro: (
        <>
          {'O '}
          <strong>Gator Protect Pro</strong>
          {' já está ativo na sua hospedagem, ajudando a manter seu site seguro no dia a dia.'}
        </>
      ),
    },
    perksTitle: 'Seu site agora conta com:',
    perks: [
      'Monitoramento contínuo',
      'Remoção automática de ameaças',
    ],
    cta: 'Ver detalhes da proteção',
    close: 'Entendi',
    additionalInfo: {
      trial: 'Ao final do teste grátis, você decide se quer continuar. Sem renovação automática e sem cobrança.',
      pro: 'Gerencie ou ajuste a proteção da sua hospedagem a qualquer momento. Este recurso já está incluso no seu plano Turbo, sem custo adicional.',
    },
  },
  detectedThreadsModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    headline: 'Seu site precisa de proteção',
    bodyPrefix: 'Identificamos ',
    threatsBold: ({ count }) => (count === 1 ? '1 ameaça' : `${count} ameaças`),
    bodySuffixLine1: ' no seu site.',
    bodyLine2: 'Ative o Gator Protect para manter tudo seguro.',
    primaryCta: 'Resolver ameaças agora',
    shieldImageAlt: 'Gator Protect powered by Monarx',
  },
  insideProductDetail: {
    tag: 'PRO',
    title: 'Gator Protect',
    isNotTurbo: {
      isFree: {
        firstRow: 'Seu site em risco. O monitoramento do seu site está ativo, mas as ameaças não são removidas automaticamente.',
        secondRow: days => (
          <>
            {'Ative a remoção automática de ameaças. Faça o '}
            <strong>
              {'teste gratuito por '}
              {days}
              {' dias.'}
            </strong>
          </>
        ),
        cta: 'Acessar proteção',
      },
      isPro: {
        withoutScan: {
          firstRow: (
            <>
              {'Seu site tem proteção completa no seu plano, mas a '}
              <strong>remoção automática de ameaças</strong>
              {' ainda não está ativa.'}
            </>
          ),
          secondRow: 'Ative agora e não corra o risco de instabilidade, alterações e bloqueios.',
          cta: 'Ir para ativação automática',
        },
        withScan: {
          firstRow: (
            <>
              {'Seu '}
              <strong>site está com proteção completa:</strong>
              {' monitoramento contínuo e remoção automática de ameaças. Mais segurança e estabilidade.'}
            </>
          ),
          cta: 'Acessar proteção',
          variant: 'secondary',
        },
      },
    },
    isTurbo: {
      isFree: {
        firstRow: (
          <>
            {'Você já tem acesso à proteção completa, '}
            <strong>sem custo adicional</strong>
            , mas a remoção automática de ameaças ainda não está ativa.
          </>
        ),
        secondRow: 'Ative agora para manter seu site protegido sempre.',
        cta: 'Acessar proteção',
      },
      isPro: {
        withoutScan: {
          firstRow: (
            <>
              {'Seu site tem proteção completa no seu plano,a '}
              <strong>remoção automática de ameaças</strong>
              {' ainda não está ativa.'}
            </>
          ),
          secondRow: 'Ative agora e não corra o risco de instabilidade, alterações e bloqueios.',
          cta: 'Ir para ativação automática',
        },
        withScan: {
          firstRow: (
            <>
              {'Seu '}
              <strong>site está com proteção completa:</strong>
              {' monitoramento contínuo e remoção automática de ameaças. Mais segurança e estabilidade.'}
            </>
          ),
          cta: 'Acessar proteção',
          variant: 'secondary',
        },
      },
    },
    isTrial: {
      firstRow: (
        <>
          <strong>Proteção completa ativa (teste gratuito)</strong>
          . Seus sites contam com monitoramento contínuo e remoção automática de ameaças.
        </>
      ),
      secondRow: 'Aproveite o período de teste para conhecer todos os benefícios.',
      cta: 'Acessar benefícios',
      variant: 'secondary',
    },
    isExpired: {
      firstRow: (
        <>
          <strong>Seu site está exposto.</strong>
          {'  O teste gratuito terminou e a proteção completa e a remoção automática de ameaças não estão mais ativas.'}
        </>
      ),
      secondRow: 'Ative porque um ataque pode tirar seu site do ar.',
      cta: 'Acessar proteção',
    },
  },
};
